// extracted by mini-css-extract-plugin
export default {"msgM":"_5583fdf2ca"};